import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BookPickupComponent } from '../book-pickup/book-pickup.component';
import { MatDialog } from '@angular/material/dialog';
import { CancelPickupComponent } from '../cancel-pickup/cancel-pickup.component';
import { PickupsService } from '../service/pickups/pickups.service';
import { environment } from 'src/environments/environment';
import { convertUTCtoUserLocalTimeZone, getUserGMT } from 'src/app/utils/utils';
import moment from 'moment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
  switchMap,
} from 'rxjs/operators';
import { merge, of as observableOf } from 'rxjs';

@Component({
  selector: 'app-pickup-list',
  templateUrl: './pickup-list.component.html',
  styleUrls: ['./pickup-list.component.css'],
})
export class PickupListComponent implements OnInit, AfterViewInit {
  public AdvFilterForm: FormGroup;
  @ViewChild('dialogRef')
  dialogRef!: TemplateRef<any>;
  environmentConfig = environment;
  pickupDataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    'pickupId',
    'created_datetime',
    'plannedPickupDateAndTime',
    'closeTime',
    'status',
    'action',
  ];
  pickupListArray = [];
  defaultPickupList = [];
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  pageSizes = [5, 10, 15];
  totalData;
  fromDate;
  toDate;
  searchKeywordFilter = new FormControl();
  constructor(
    public dialog: MatDialog,
    private pickupService: PickupsService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.getPickupQuery();
    this.filterBySearch();
    this.initializationformGroup();
    this.pickupDataSource.paginator = this.paginator;
    // this.pickupDataSource.sort = this.sort;
  }
  sortDate(data) {
    return data.sort((a, b) => {
      return <any>new Date(b.bookingDate) - <any>new Date(a.bookingDate);
    });
  }

  getPickupData() {
    this.getPickupQuery();

    const rqst = {
      query: {
        daterange: { datefield: 'created_datetime', fromdate: this.fromDate, todate: this.toDate },
        status: ['Booked', 'Booking Cancelled'],
      },
      limit: this.paginator.pageSize,
      page: 1,
      search: this.searchKeywordFilter.value == null ? '' : this.searchKeywordFilter.value,
      sort: 'created_datetime',
      sortOrder: -1,
    };

    this.getPickupList(rqst);
  }

  getPickupQuery() {
    this.fromDate = moment().subtract(30, 'days').format('YYYYMMDD');
    this.toDate = moment().add(2, 'days').format('YYYYMMDD');
  }

  filterBySearch() {
    this.searchKeywordFilter.valueChanges
      .pipe(debounceTime(3000), distinctUntilChanged())
      .subscribe(() => {
        const rqst = {
          query: {
            daterange: {
              datefield: 'created_datetime',
              fromdate: this.fromDate,
              todate: this.toDate,
            },
            status: ['Booked', 'Booking Cancelled'],
          },
          limit: this.paginator.pageSize,
          page: 1,
          search: this.searchKeywordFilter.value == null ? '' : this.searchKeywordFilter.value,
          sort: 'created_datetime',
          sortOrder: -1,
        };
        this.getPickupList(rqst);
        this.pickupDataSource.paginator = this.paginator;
        this.pickupDataSource.sort = this.sort;
      });
  }

  convertTo12Hour(oldFormatTime) {
    const oldFormatTimeArray = oldFormatTime.split(':');
    const HH = parseInt(oldFormatTimeArray[0]);
    const min = oldFormatTimeArray[1];
    const AMPM = HH >= 12 ? 'PM' : 'AM';
    let hours;
    if (HH == 0) {
      hours = HH + 12;
    } else if (HH > 12) {
      hours = HH - 12;
    } else {
      hours = HH;
    }
    const newFormatTime = hours + ':' + min + ' ' + AMPM;
    return newFormatTime;
  }

  openBookPickup() {
    const dialogRef = this.dialog.open(BookPickupComponent, {
      disableClose: true,
      autoFocus: false,
      maxHeight: '100vh',
      maxWidth: '90vw',
      data: {},
    });
    dialogRef.afterClosed().subscribe(close => {
      if (close) {
        this.getPickupData();
      }
    });
  }

  openCancelPickup(rowData) {
    const dialogRef = this.dialog.open(CancelPickupComponent, {
      disableClose: true,
      autoFocus: false,
      maxHeight: '75vh',
      maxWidth: '40vw',
      data: { rowData },
    });
    dialogRef.afterClosed().subscribe(close => {
      if (close) {
        this.getPickupData();
      }
    });
  }

  initializationformGroup() {
    this.AdvFilterForm = this.fb.group({
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
    });
  }

  applyAdvFilter() {
    this.dialog.closeAll();
    if (this.AdvFilterForm.value.startDate) {
      const d = this.AdvFilterForm.value.startDate._d;
      let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate();
      const year = d.getFullYear();
      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }
      this.fromDate = year + month + day;
    }

    if (this.AdvFilterForm.value.endDate) {
      const d = this.AdvFilterForm.value.endDate._d;
      let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate();
      const year = d.getFullYear();
      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }
      this.toDate = year + month + day;
    }

    const rqst = {
      query: {
        daterange: { datefield: 'created_datetime', fromdate: this.fromDate, todate: this.toDate },
        status: ['Booked', 'Booking Cancelled'],
      },
      limit: this.paginator.pageSize,
      page: 1,
      search: this.searchKeywordFilter.value == null ? '' : this.searchKeywordFilter.value,
      sort: 'created_datetime',
      sortOrder: -1,
    };
    this.getPickupList(rqst);
    this.AdvFilterForm.reset();
  }

  getPickupList(pReqBody) {
    this.pickupService.getPickupList(pReqBody).subscribe({
      next: res => {
        this.formatPickupList(res);
      },
    });
  }

  openFilterDialog() {
    const myTempDialog = this.dialog.open(this.dialogRef, {
      maxHeight: '75vh',
      maxWidth: '40vw',
      data: '',
    });
    myTempDialog.afterClosed().subscribe(() => ``);
  }

  isAdvancedFilterCheck() {
    return !(this.AdvFilterForm.get('startDate').valid && this.AdvFilterForm.get('endDate').valid);
  }

  onRefresh() {
    this.getPickupData();
  }

  closeDialog() {
    this.dialog.closeAll();
    this.AdvFilterForm.reset();
  }

  ngAfterViewInit() {
    // this.pickupDataSource.paginator = this.paginator;
    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    merge(this.sort.sortChange, this.paginator.page)
      //this.paginator.page
      .pipe(
        startWith({}),
        switchMap(() => {
          const rqst = {
            query: {
              daterange: {
                datefield: 'created_datetime',
                fromdate: this.fromDate,
                todate: this.toDate,
              },
              status: ['Booked', 'Booking Cancelled'],
            },
            limit: this.paginator.pageSize,
            page: this.paginator.pageIndex + 1,
            search: this.searchKeywordFilter.value == null ? '' : this.searchKeywordFilter.value,
            sort: this.sort.active,
            sortOrder: this.sort.direction === 'desc' ? -1 : 1,
          };
          return this.pickupService.getPickupList(rqst).pipe(catchError(() => observableOf(null)));
        }),
        map(empData => {
          if (empData == null) {
            this.totalData = 0;
            return [];
          }
          return empData;
        })
      )
      .subscribe(empData => {
        this.formatPickupList(empData);
      });
  }

  formatPickupList(result) {
    this.pickupListArray = [];
    if (result.data.length > 0) {
      const pickupData = result.data;
      for (const pickupId of pickupData) {
        const dataObj: any = {};
        dataObj.confirmationNumber = pickupId.pickup_id;
        dataObj.status = pickupId.status;
        const pickupTime = pickupId.plannedPickupDateAndTime.split('T')[1];
        dataObj.reqPickupDate = pickupId.plannedPickupDateAndTime;
        const ReadyTimeIn12Hr = this.convertTo12Hour(pickupTime);
        const closeTimeIn12Hr = this.convertTo12Hour(pickupId.closeTime);
        dataObj.reqPickupWindow = ReadyTimeIn12Hr + ' - ' + closeTimeIn12Hr;
        dataObj.bookingDate = convertUTCtoUserLocalTimeZone(
          pickupId.created_datetime,
          pickupId?.timezone ? pickupId.timezone : getUserGMT(),
          moment.tz.guess()
        );
        this.pickupListArray.push(dataObj);
      }
      this.totalData = result.totalCount;
    } else {
      this.totalData = 0;
    }
    this.pickupListArray = this.sortDate(this.pickupListArray);
    this.defaultPickupList = this.pickupListArray;
    this.pickupDataSource = new MatTableDataSource(this.pickupListArray);
  }
}
